const mutationTypes = {
  SET_PAGE_TITLE: 'setPageTitle', // 画面のタイトル設定
  SET_INITIAL_ROUTE: 'setInitialRoute', // 最初にアクセスされたRoute設定
  RESTORE_INITIAL_ROUTE: 'restoreInitialRoute', // 最初にアクセスされたRouteを復元する
  SET_AUTH: 'setAuth', // 認証情報の設定
  SET_NOTIFICATION: 'setNotification', // おしらせ1件設定
  SET_NOTIFICATIONS: 'setNotifications', // おしらせ一覧設定
  SET_FILES: 'setFiles', // ファイル一覧情報の設定
  SET_WELFARE: 'setWelfare', // おしらせ1件設定
  SET_WELFARES: 'setWelfares', // おしらせ一覧設定
};
export default mutationTypes;